import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { GoTopBtn } from '../components/GoTopBtn';
import { Server_URL } from "../config.js";
import './ListingProducts.css';

function ListingSensorsBySize() {
  const [sensors, setSensors] = useState([]);
  const { id } = useParams();
  const PdfDrawing = 'SensorDrawing,';
  const PdfSpec = 'SensorSpec,';
  const navigate = useNavigate();
  // const [deleted, setDeleted] = useState(true);
  // const [keyin, setKeyin] = useState([]);

  useEffect(() => {
    axios
      .get(`${Server_URL}/get_sensors_size/${id}`)
      .then((res) => { setSensors(res.data); })
      .catch((err) => console.log(err))
  }, [id]);

  return (
    <section id="listsensor" className="block listsensor-block">
      <div className='container-fluid'>
        {/* <div className='container-fluid bg-primary vh-100 vw-100'> */}
        <br /> <br /> <br /> <br /> <br />
        <div> <h2 className='text-center'>Sensor List</h2> </div>
        {/* <div> <h1 className='listingsensor'> </h1> </div> */}
        <div className='d-flex justify-content-center'>
          <button className='btn btn-success' onClick={() => navigate(-1)}>Back</button>
        </div>
        <br />
        <h3 className='text-center'>Sensor Size: {id}</h3>
        <table>
          <thead className='fs-6 text-center bg-success-subtle'>
            <tr>
              <th>SNo</th> <th>Size</th> <th>-PartNo-</th> <th>Ratio</th>
              <th>-SensorOD-</th> <th>-SensorAA-</th> <th>SGThick</th>
              <th>-CoverVA-</th>
              <th>-ChnRxTx-</th> <th>-CtrlCard/IC-</th>
              <th>-RegDate-</th> <th>-Note-</th> <th>-DrawYes-</th>
              <th>-Actions-</th>
            </tr>
          </thead>

          <tbody className='m-1 px-1 fs-6 text-center bg-primary-subtle'> {
            sensors.map((sensor, i) => {
              return (
                <tr key={i++} className={(i % 2) ? "bg-success-primary" : 'bg-light'}>
                  <td>{sensor.SNo}</td> <td>{sensor.Size}</td> <td>{sensor.PartNo}</td> <td>{sensor.Ratio}</td>
                  <td>{sensor.SensorOD}</td> <td>{sensor.SensorAA}</td> <td>{sensor.SensorThick}</td>
                  <td>{sensor.CoverVA}</td>
                  <td>{sensor.ControlCard}</td> <td>{sensor.ChannelRxTx}</td>
                  <td>{sensor.RegistDate}</td> <td>{sensor.Note}</td> <td>{sensor.DrawYes}</td>
                  <td>
                    <Link to={`/ShowSensorDetail/${sensor.SNo}`} className='btn trbtn-success p-1'>Read</Link>
                    <Link to={`/ViewPDF/${PdfDrawing + sensor.PartNo}`} className='btn trbtn-success m-1 p-1'>Drawing</Link>
                    <Link to={`/ViewPDF/${PdfSpec + sensor.PartNo}`} className='btn trbtn-success p-1'>Spec</Link>
                  </td>
                </tr>
              )
            })
          } </tbody>
        </table >
        <br />
        <div className='d-flex justify-content-center'>
          <button className='btn btn-success' onClick={() => navigate(-1)}>Back</button>
        </div>
        <div> < GoTopBtn /> </div>
      </div >
    </section>
  )
}

export default ListingSensorsBySize;

// useEffect(() => {
//   // if (deleted) {
//   console.log('into ListingSensorsBySize() ', `${Server_URL}/get_sensors_size/${id}`);
//   // setDeleted(false);
//   axios
//     .get(`${Server_URL}/get_sensors_size/${id}`)
//     // .get(`http://localhost:3022/get_sensors_size/${id}`)
//     // .then((res) => { setSensors(res.data); console.log(Sensors); })
//     .then((res) => { setSensors(res.data); })
//     .catch((err) => console.log(err))
//   // }
// }, [id]);


// function handleDelete(id) {
//   axios
//     .delete(`${Server_URL}:3022/delete_sensor/${id}`)
//     // .delete(`http://localhost:3022/delete_sensor/${id}`)
//     // .delete(`http://localhost:5000/delete_sensor/${id}`)
//     .then((res) => { setDeleted(true) })
//     .catch((err) => console.log(err))
// }

// <div className='d-flex justify-content-center'>
// <button className='btn btn-success' onClick={() => navigate(-1)}>Back</button>
// /* <div className='d-flex justify-content-start'> */
// /* <Link to="/ListingSensorsBySize/${keyin}" className='btn trbtn-success'>Back</Link> */
// /* <input value={keyin} type="text" placeholder="Size..." onChange={(e) => setKeyin(e.target.value)} /> */
// /* <button className='btn trbtn-success' onClick={() => navigate(`/ShowSensorsSize/${keyin}`)}>Sensor Size</button> */
// /* <Link to={`/ListingSensorsBySize/${keyin}`} className='btn mx-2 btn-success'>Select Sensor Size</Link> */
// </div>

// {/* <table className='table table-bordered vw-100'> */}
// {/* <table className='table'> */}
// <table>
//   {/* <thead className='m-1 px-1 fs-6 text-center bg-success-subtle'> */}
//   <thead className='fs-6 text-center bg-success-subtle'>
//     <tr>
//       <th>SNo</th> <th>Size</th> <th>-PartNo-</th> <th>Ratio</th>
//       <th>-SensorOD-</th> <th>-SensorAA-</th> <th>SGThick</th>
//       <th>-CoverVA-</th>
//       <th>-ChnRxTx-</th> <th>-CtrlCard/IC-</th>
//       <th>-RegDate-</th> <th>-Note-</th> <th>-DrawYes-</th>
//       <th>-Actions-</th>
//       {/*
//       <th>SNo</th> <th>Size</th> <th>-----PartNo-----</th> <th>Ratio</th>
//       <th>---SensorOD----</th> <th>--SensorAA--</th> <th>SGThick</th>
//       <th>---CoverVA----</th>
//       <th>-ChnRxTx-</th> <th>-CtrlCard/IC-</th>
//       <th>FPCLocation，</th> <th>ScreenPartNo，</th> <th>CustomerPartNo，</th>
//       <th>--RegDate--</th> <th>---Note---</th> <th>--DrawYes--</th>
//       <th>--------Actions--------</th>
//       <th>-Note-</th> <th>-Actions-</th>
//       <th>--</th>
//       */}
//     </tr>
//   </thead>

//   <tbody className='m-1 px-1 fs-6 text-center bg-primary-subtle'> {
//     sensors.map((sensor, i) => {
//       // console.log(" sensor.SNo :", sensor.SNo, " sensor.PartNo :", sensor.PartNo);
//       return (
//         <tr key={i++} className={(i % 2) ? "bg-success-primary" : 'bg-light'}>
//           <td>{sensor.SNo}</td> <td>{sensor.Size}</td> <td>{sensor.PartNo}</td> <td>{sensor.Ratio}</td>
//           <td>{sensor.SensorOD}</td> <td>{sensor.SensorAA}</td> <td>{sensor.SensorThick}</td>
//           <td>{sensor.CoverVA}</td>
//           <td>{sensor.ControlCard}</td> <td>{sensor.ChannelRxTx}</td>
//           {/* <td>{sensor.FpcLoc}</td> <td>{sensor.PrintPN}</td> <td>{sensor.CustomerPN}</td> */}
//           <td>{sensor.RegistDate}</td> <td>{sensor.Note}</td> <td>{sensor.DrawYes}</td>
//           <td>
//             <Link to={`/ShowSensorDetail/${sensor.SNo}`} className='btn trbtn-success p-1'>Read</Link>
//             <Link to={`/ViewPDF/${PdfDrawing + sensor.PartNo}`} className='btn trbtn-success m-1 p-1'>Drawing</Link>
//             <Link to={`/ViewPDF/${PdfSpec + sensor.PartNo}`} className='btn trbtn-success p-1'>Spec</Link>
//             {/* <Link to={`/ViewPDF/${PdfSpec + sensor.PartNo}`} className='btn trbtn-success m-1 p-1'>Spec</Link> */}
//           </td>
//           {/* <td>--</td> */}
//         </tr>
//       )
//     })
//   } </tbody>
// </table >
